import React, { useState } from "react";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { message } from "antd";
import TextStyles from "../../../../../../Constants/TextStyles";
import Styled from "../../PageOne/PageOne";
import { useDispatch, useSelector } from "react-redux";
import { updateContractorTaxIdPC } from "../../../../../../store/service/proposalAndContractService";
import RemoveModal from "../../../../Commons/RemoveModal";
import Colors from "../../../../../../Constants/Colors";

import ContractorTaxIdModal from "../../PageModals/ContractorTaxIdModal.jsx";

const ContractorTaxId = () => {
  const selectedData = useSelector(
    (state) => state.proposalAndContract.selectedData
  );
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const handleCloseRemoveModal = () => setShowRemoveModal(false);

  const heading =
    selectedData &&
    selectedData.contractor_tax_id &&
    selectedData.contractor_tax_id.heading
      ? selectedData &&
        selectedData.contractor_tax_id &&
        selectedData.contractor_tax_id.heading
      : "Contractor's Taxpayer I.D. Number";
  const paragraph =
    selectedData &&
    selectedData.contractor_tax_id &&
    selectedData.contractor_tax_id.paragraph
      ? selectedData &&
        selectedData.contractor_tax_id &&
        selectedData.contractor_tax_id.paragraph
      : "The taxpayer I.D. number of the Contractor is [_________] (SSN/BIN if you are a Canadian citizen). The Contractor is licensed to perform the agreed-upon services enumerated herein and covenants that it maintains all valid licenses, permits, and registrations to perform the same as required by law.";

  const hideClauseHandler = () => {
    const Obj = {
      _id: selectedData._id,
      contractor_tax_id: {
        required: false,
        heading: null,
        paragraph: null,
      },
    };
    dispatch(updateContractorTaxIdPC(Obj)).then((data) => {
      if (data.meta.requestStatus === "fulfilled") {
        handleCloseRemoveModal();
        message.success("Clause hidden successfully!");
      } else {
        message.error(`${data.error.message}!`);
      }
    });
  };

  return (
    <div
      style={{
        display:
          selectedData &&
          selectedData.contractor_tax_id &&
          selectedData.contractor_tax_id.required === true
            ? "inline"
            : "none",
      }}
    >
      <Styled.ReviewContentBox className="mt-4">
        <Styled.EditButtonToolTip
          className="contract_review_edit_tp"
          style={{ marginLeft: -60 }}
          onClick={() => setShowModal(true)}
        >
          <BorderColorOutlinedIcon sx={{ color: Colors.white, fontSize: 20 }} />
          <span className="ms-1">Edit</span>
        </Styled.EditButtonToolTip>
        <Styled.EditButtonToolTip
          backgroundColor="#383838"
          className="contract_review_edit_tp"
          style={{ marginLeft: 60 }}
          onClick={() => {
            setShowRemoveModal(true);
            setConfirmDialog({
              onConfirm: hideClauseHandler,
            });
          }}
        >
          <VisibilityOffIcon sx={{ color: Colors.white, fontSize: 20 }} />
          <span className="ms-1">Hide</span>
        </Styled.EditButtonToolTip>

        <TextStyles.FontSize20px className="mb-2">
          {heading}
        </TextStyles.FontSize20px>
        <TextStyles.FontSize14px>{paragraph}</TextStyles.FontSize14px>
      </Styled.ReviewContentBox>
      {showModal && (
        <ContractorTaxIdModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          heading={heading}
          paragraph={paragraph}
          selectedData={selectedData}
        />
      )}
      {confirmDialog && (
        <RemoveModal
          title={heading}
          confirmDialog={confirmDialog}
          showRemoveModal={showRemoveModal}
          handleCloseRemoveModal={handleCloseRemoveModal}
        />
      )}
    </div>
  );
};

export default ContractorTaxId;
